// 点
import rlEntity from "./rlEntity";
import {
  create2dAnyPoint,
  create3dAnyPoint,
  create2dAnyLine,
} from "../threeObject/index";

import mxcad from "mxcad";

import { addEntityToDrawing } from "@/rlMxModules/operate/commonApi";
const { McDbPoint, McDbLine, McCmColor } = mxcad;
import store from "@/store";
import { fixOrthogonal } from "@/rlMxModules/utils/util";
import { resetRlModules } from "@/mixins/LiteModuleDb.js";

class rlPoint extends rlEntity {
  constructor() {
    super();
    this.m_pt = null; // 节点坐标

    this.classTypeName = "rlJoint"; // 点
    this.mcDbPoint = new McDbPoint(); //关联的cad节点类
    this.mcDbPointId = null; //关联的cad节点类id

    this._threeObj = null; //三维图形对象

    this.m_gridIds = new Array(); //节点所在的网格集合
    this.m_cloumId = null; //节点位置的墙柱id
    this.m_AxisIds = new Array(); //节点所在的轴线集合
    this.m_slabHoleId = null; //节点上的板洞

    this.m_groupName = "rlPointGroup";
    this.points = []; // 点列表
  }

  // 自定义对象在绘制时会重新创建
  create() {
    return new this.constructor();
  }

  initData(obj) {
    super.initData(obj);
    this.m_pt = obj.m_pt;
  }

  //用于撤销回退
  reDraw(obj) {
    super.reDraw(obj);
    this.m_pt = obj.m_pt;

    this.m_gridIds = obj.m_gridIds; //节点所在的网格集合
    this.m_cloumId = obj.m_cloumId; //节点位置的墙柱id
    this.m_AxisIds = obj.m_AxisIds; //节点所在的轴线集合
    this.m_slabHoleId = obj.m_slabHoleId; //节点上的板洞
  }

  // 添加
  add(obj) {
    this.m_pt = obj.m_pt;
    this.m_stdFlrGuid = obj.m_stdFlrGuid;
    this.Guid = obj.Guid ? obj.Guid : this.Guid;
  }

  // 生成节点
  setPoints(m_pt) {
    this.m_pt = m_pt;
  }

  //数据修改更新
  async updateThisObj(obj) {
    this.initData(obj);
    this.setNeedUpdateDisplay();
    await resetRlModules(
      this.classTypeName,
      store.state.globalData.rl_stdFlr_id,
      this.Guid,
      this.getDataBase()
    );
  }

  // 克隆
  myClone() {
    let newObj = this.clone();
    newObj.m_pt = [...this.m_pt];
    newObj.mcDbPoint = new McDbPoint();
    newObj.mcDbPointId = null; //关联的cad节点类id
    newObj.m_gridIds = new Array(); //节点所在的网格集合

    newObj.m_cloumId = null; //节点位置的墙柱id
    newObj.m_AxisIds = new Array();
    return newObj;
  }

  // 绘制
  worldDraw(pWorldDraw) {
    let wPointObj;
    if (pWorldDraw.mxObj._is2d) {
      this.mcDbPoint.setPosition(this.m_pt[0], this.m_pt[1], this.m_pt[2]);
      this.mcDbPoint.trueColor = new McCmColor(0, 0, 0);
      this.mcDbPoint.setxDataString("mcObjectId", this.objectId().toString());
      wPointObj = create2dAnyPoint(this.m_pt);
    }
    // 动态绘制这个点对象
    this._threeObj = create3dAnyPoint(this.m_pt);
    pWorldDraw.drawEntity(wPointObj);
  }

  erase() {
    //处理关联的柱
    if (this.m_cloumId) {
      let objtmp = rlAppObj.rlMxDrawObject.getMxEntity(this.m_cloumId);
      if (objtmp) objtmp.erase();
    }
    //处理关联的网格
    if (this.m_gridIds) {
      if (this.m_gridIds.length > 1) {
        let gridOnAxis = {}; //轴线上的网格集合--键值对,key是轴线对象的id，value是轴线下的网格
        this.m_gridIds.forEach((item) => {
          let objtmp = rlAppObj.rlMxDrawObject.getMxEntity(item);
          if (objtmp && objtmp.m_Axis) {
            // let axisTmp = objtmp.m_Axis.objectId();
            if (gridOnAxis[objtmp.m_Axis.Guid] == undefined)
              gridOnAxis[objtmp.m_Axis.Guid] = [];

            gridOnAxis[objtmp.m_Axis.Guid].push(objtmp);
          }
        });

        Object.keys(gridOnAxis).forEach((key) => {
          const value = gridOnAxis[key]; //轴线下的网格

          if (value.length == 2) {
            //有两个网格，将两个网格连成一个
            //修改value[0]对象
            value[0].saveEditRevokeData(); //修改数据前保存数据

            if (value[0].m_stJoint == this) {
              if (value[1].m_stJoint == this) {
                value[0].m_stJoint = value[1].m_edJoint;
              } else {
                value[0].m_stJoint = value[1].m_stJoint;
              }

              value[0].updateThisObj(value[0]);
            } else if (value[0].m_edJoint == this) {
              if (value[1].m_stJoint == this) {
                value[0].m_edJoint = value[1].m_edJoint;
              } else {
                value[0].m_edJoint = value[1].m_stJoint;
              }

              value[0].updateThisObj(value[0]);
            }

            //删掉另外一段网格
            // let objtmp = rlAppObj.rlMxDrawObject.getMxEntity(value[1]);
            if (value[1]) {
              value[1].erase();
            }
          } else if (value.length == 1) {
            // let objtmp = rlAppObj.rlMxDrawObject.getMxEntity(value[0]);
            if (value[0]) {
              value[0].erase();
            }
          }
        });
      } else if (this.m_gridIds.length == 1) {
        //节点属于单个网格
        let objtmp = rlAppObj.rlMxDrawObject.getMxEntity(this.m_gridIds[0]);
        if (objtmp) {
          objtmp.erase();
        }
      }
    }

    //处理关联的轴线
    if (this.m_AxisIds.length > 0) {
      this.m_AxisIds.forEach((axisId) => {
        let objtmp = rlAppObj.rlMxDrawObject.getMxEntity(axisId);
        if (objtmp) {
          objtmp.updateData(this);
        }
      });
    }

    this.mcDbPointId?.getMcDbEntity().erase();
    //同步删除indexdb
    //to do...
    super.erase();
  }

  // 输出同理
  dwgOut(obj) {
    this.onDwgOut(obj);
    obj.m_pt = this.m_pt;
    obj.mcDbPoint = this.mcDbPoint;
    obj.mcDbPointId = this.mcDbPointId;
    obj._threeObj = this._threeObj;
    obj.m_gridIds = this.m_gridIds;
    obj.m_cloumId = this.m_cloumId;
    obj.m_AxisIds = this.m_AxisIds;
    return obj;
  }

  // 数据读入
  dwgIn(obj) {
    // // 这里是公共的属性
    this.onDwgIn(obj);
    this.m_pt = obj.m_pt;
    this.mcDbPoint = obj.mcDbPoint;
    this.mcDbPointId = obj.mcDbPointId;
    this._threeObj = obj._threeObj;
    this.m_gridIds = obj.m_gridIds;
    this.m_cloumId = obj.m_cloumId;
    this.m_AxisIds = obj.m_AxisIds;
    return true;
  }

  // 返回图形源数据
  getDataBase() {
    let data = super.getDataBase();

    data["X"] = this.m_pt[0];
    data["Y"] = this.m_pt[1];
    data["Z"] = this.m_pt[2];

    return data;
  }

  //获取图形绘制数据--用于撤销回退
  getDrawData() {
    let data = super.getDrawData();
    data["m_pt"] = this.m_pt;

    //关联数据
    data["m_gridIds"] = this.m_gridIds;
    data["m_cloumId"] = this.m_cloumId;
    data["m_AxisIds"] = this.m_AxisIds;
    data["m_slabHoleId"] = this.m_slabHoleId;

    return data;
  }

  // 绘制
  // pointsUpdate(s, e) {
  //   this.points = [s, e];
  // }

  // 偏移
  async transformBy(_mat) {
    await this.saveEditRevokeData(); //修改数据前保存数据

    let pt = new THREE.Vector3(...this.m_pt).add(_mat).toArray();
    this.m_pt = pt;

    if (this.m_cloumId) {
      //柱
      let objtmp = rlAppObj.rlMxDrawObject.getMxEntity(this.m_cloumId);
      if (objtmp) {
        await objtmp.saveEditRevokeData();
        // let position = objtmp.m_TextObj.position
        // objtmp.m_TextObj.transformBy(mat);
        objtmp.setNeedUpdateDisplay();
      }
    }

    if (this.m_gridIds) {
      //网格
      for (let i = 0; i < this.m_gridIds.length; i++) {
        const element = this.m_gridIds[i];
        let objtmp = rlAppObj.rlMxDrawObject.getMxEntity(element);
        if (objtmp) {
          await objtmp.saveEditRevokeData();
          objtmp.setNeedUpdateDisplay();
        }
      }
    }
    if (this.m_AxisIds) {
      //轴线
      for (let i = 0; i < this.m_AxisIds.length; i++) {
        const element = this.m_AxisIds[i];
        let objtmp = rlAppObj.rlMxDrawObject.getMxEntity(element);
        if (objtmp) {
          await objtmp.saveEditRevokeData();
          objtmp.setNeedUpdateDisplay();
        }
      }
    }

    if (this.mcDbPointId) {
      this.mcDbPointId
        .getMcDbEntity()
        .setPosition(this.m_pt[0], this.m_pt[1], this.m_pt[2]);
    }
    this.updateThisObj(this);

    // this.updateThisObj(this);
  }

  // 画点(参数录入)
  async drawPointByParam(point) {
    return new Promise((resolve, reject) => {
      this.m_pt = [point.x, point.y, point.z];
      addEntityToDrawing(this);
      resolve(this);
    });
  }

  // 画点(模数录入)
  async drawPoint(nodeSimulate) {
    return new Promise((resolve, reject) => {
      // 实例化取点对象
      const getPoint = new rlAppObj._rlMx.MrxDbgUiPrPoint();
      let endPoint = null;
      fixOrthogonal(false);
      // 鼠标第一次点击
      getPoint.go((status) => {
        if (status === -1) {
          store.commit("platBtns/CHANGE_MOVEBOX", {
            id: store.state.platBtns.topBtnActive.drawId,
            bol: false,
          });
        }
        if (status != 0 || !nodeSimulate) {
          return;
        }
        store.commit("drawModules/setDrawPlay", true);
        fixOrthogonal(true);
        // 当前鼠标位置
        if (store.state.platBtns.topBtnActive.id !== 101) return;
        this.points.push(getPoint.value());
        const PI_HALF = Math.PI / 2;
        getPoint.setUserDraw((currentPoint, pWorldDraw) => {
          fixOrthogonal(true);
          if (this.points.length >= 1) {
            const startPoint = this.points[0];
            endPoint = currentPoint.clone(); // 克隆当前点作为终点
            const distance = startPoint.distanceTo(endPoint); // 计算距离
            const modulusDistance =
              Math.ceil(distance / nodeSimulate) * nodeSimulate; // 将距离调整到模数的最近整数倍

            // 保持方向不变，调整endPoint到模数的最近整数倍距离
            endPoint
              .sub(startPoint)
              .normalize()
              .multiplyScalar(modulusDistance)
              .add(startPoint);

            // 计算两点之间的角度
            let angle = Math.atan2(
              endPoint.y - startPoint.y,
              endPoint.x - startPoint.x
            );
            let angleValue = ((angle * 180) / Math.PI + 360) % 360;
            const value =
              modulusDistance.toFixed(2) +
              "mm" +
              "  " +
              (angleValue === 360 ? 0 : angleValue).toFixed(2) +
              "°";

            // 修正角度在左右侧的显示
            if (angle > PI_HALF || angle < -PI_HALF) {
              angle -= Math.PI;
            }

            // 绘制文本和线条
            const textSize = modulusDistance / 10;
            const midPoint = new THREE.Vector3().lerpVectors(
              startPoint,
              endPoint,
              0.5
            );
            midPoint.y += textSize;
            pWorldDraw.drawText(value, textSize, angle, midPoint);
            pWorldDraw.drawLine(startPoint, endPoint); // 绘制线段，长度为模数的整数倍
          }
        });

        // 鼠标第二次
        getPoint.go((status2) => {
          // 鼠标右键结束绘制
          if (status2 !== 0) {
            return resolve();
          }
          // 最后一个点位置
          this.m_pt = endPoint.toArray();
          addEntityToDrawing(this);
          resolve(this);
        });
      });
      store.commit("drawModules/setDrawPlay", false);
    });
  }

  // 画点
  async draw() {
    return new Promise((resolve, reject) => {
      // 实例化取点对象
      const getPoint = new rlAppObj._rlMx.MrxDbgUiPrPoint();
      // fixOrthogonal(false);
      // 鼠标第一次点击
      getPoint.go((status) => {
        //右键关闭
        if (status === -1) {
          store.commit("platBtns/CHANGE_MOVEBOX", {
            id: store.state.platBtns.topBtnActive.drawId,
            bol: false,
          });
        }
        if (status != 0) {
          return;
        }
        // 当前鼠标位置
        this.m_pt = getPoint.value().toArray();
        if (store.state.platBtns.topBtnActive.id !== 101) return;
        addEntityToDrawing(this);
        resolve(this);
      });
    });
  }

  // 移动端画点
  async draw_mobile() {
    return new Promise((resolve, reject) => {
      // 实例化取点对象
      const getPoint = new rlAppObj._rlMx.MrxDbgUiPrPoint();
      // 鼠标第一次点击
      getPoint.go((status) => {
        // 当前鼠标位置
        if (status != 0) {
          store.commit("drawModules/setDrawPlay", false);
          return resolve();
        }
        getPoint.go((status2) => {
          if (status2 != 0) {
            store.commit("drawModules/setDrawPlay", false);
            return resolve();
          }
          // 当前鼠标位置
          this.m_pt = getPoint.value().toArray();
          if (store.state.platBtns.topBtnActive.id !== 101) return;
          addEntityToDrawing(this);
          resolve(this);
        });
      });
    });
  }

  // 移动端画点(模数录入)
  async drawMobilePoint(nodeSimulate) {
    return new Promise((resolve, reject) => {
      // 实例化取点对象
      const getPoint = new rlAppObj._rlMx.MrxDbgUiPrPoint();
      let endPoint = null;
      fixOrthogonal(false);

      try {
        // 鼠标第一次点击,选点
        getPoint.go((status) => {
          // getPoint.setInputToucheType(1);
          if (status === -1) {
            store.commit("platBtns/CHANGE_MOVEBOX", {
              id: store.state.platBtns.topBtnActive.drawId,
              bol: false,
            });
          }
          if (status != 0 || !nodeSimulate) {
            return;
          }
          store.commit("drawModules/setDrawPlay", true);
          getPoint.go((status2) => {
            if (status2 !== 0) {
              store.commit("drawModules/setDrawPlay", false);
              return resolve();
            }
            fixOrthogonal(true);
            // 当前鼠标位置
            if (store.state.platBtns.topBtnActive.id !== 101) return;
            this.points.push(getPoint.value());
            const PI_HALF = Math.PI / 2;
            getPoint.setUserDraw((currentPoint, pWorldDraw) => {
              fixOrthogonal(true);
              if (this.points.length >= 1) {
                const startPoint = this.points[0];
                endPoint = currentPoint.clone(); // 克隆当前点作为终点
                const distance = startPoint.distanceTo(endPoint); // 计算距离
                const modulusDistance =
                  Math.ceil(distance / nodeSimulate) * nodeSimulate; // 将距离调整到模数的最近整数倍

                // 保持方向不变，调整endPoint到模数的最近整数倍距离
                endPoint
                  .sub(startPoint)
                  .normalize()
                  .multiplyScalar(modulusDistance)
                  .add(startPoint);

                // 计算两点之间的角度
                let angle = Math.atan2(
                  endPoint.y - startPoint.y,
                  endPoint.x - startPoint.x
                );
                let angleValue = ((angle * 180) / Math.PI + 360) % 360;
                const value =
                  modulusDistance.toFixed(2) +
                  "mm" +
                  "  " +
                  (angleValue === 360 ? 0 : angleValue).toFixed(2) +
                  "°";

                // 修正角度在左右侧的显示
                if (angle > PI_HALF || angle < -PI_HALF) {
                  angle -= Math.PI;
                }

                // 绘制文本和线条
                const textSize = modulusDistance / 10;
                const midPoint = new THREE.Vector3().lerpVectors(
                  startPoint,
                  endPoint,
                  0.5
                );
                midPoint.y += textSize;
                pWorldDraw.drawText(value, textSize, angle, midPoint);
                pWorldDraw.drawLine(startPoint, endPoint); // 绘制线段，长度为模数的整数倍
              }
            });

            // 鼠标第二次
            getPoint.go((status3) => {
              // 鼠标右键结束绘制
              if (status3 !== 0) {
                return resolve();
              }
              // 最后一个点位置
              this.m_pt = endPoint.toArray();
              addEntityToDrawing(this);
              resolve(this);
            });
          });
        });
      } catch (error) {}
      store.commit("drawModules/setDrawPlay", false);
    });
  }
  // 移动端画点(参数录入)
  async drawMobilePointByParam(point) {
    return new Promise((resolve, reject) => {
      this.m_pt = [point.x, point.y, point.z];
      addEntityToDrawing(this);
      resolve(this);
    });
  }
}

export { rlPoint };
